// 9fbef606107a605d69c0edbcd8029e5d
import { parseBoolean } from '@tcp/core/src/utils';
import { formValueSelector } from 'redux-form';
import BagPageSelector from '../../../../../../BagPage/container/BagPage.selectors';

export const getGiftWrapOptions = (state) => {
  const giftWrapOptions = state.Checkout.getIn(['options', 'giftWrapOptions']);
  return giftWrapOptions.text || '';
};

export const getDetailsContent = (state, brand) => {
  const detailsContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) => moduleX?.name === BagPageSelector.getGiftServicesContentInfo(brand)?.name
  );
  return detailsContent && detailsContent?.richText;
};

export const getDetailsContentZymboorie = (state) => {
  const detailsContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) => moduleX.name === BagPageSelector.getGiftServicesContentGymInfo(state).name
  );
  return detailsContent && detailsContent.richText;
};
export const getInitialGiftWrapOptions = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'checkout', 'giftWrap']);
};

export const getFormGiftMsg = (state) => {
  return state.Checkout.getIn(['options', 'giftWrapOptions', 'text', 'GiftMsg']) || '';
};

export const getFormCatEntryId = (state) => {
  return state.Checkout.getIn(['options', 'giftWrapOptions', 'text', 'catEntryId']) || '';
};

export const getCartOrderDetails = (state) => {
  return state.CartPageReducer.get('orderDetails');
};

export const getCartOrderId = (state) => {
  return getCartOrderDetails(state).get('orderId');
};

export const getShippingSelected = (state) => {
  const selector = formValueSelector('GiftServices');
  return selector(state, 'hasGiftWrapping');
};

export const supressGiftServicesOnLoad = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.SUPRESS_GIFT_SERVICES_ON_LOAD_APP)
  );
};

export const getIsGiftServicesLoadingFlag = (state) => {
  return state.Checkout.getIn(['values', 'isGiftServicesLoading']) || false;
};
